import { Chip, makeStyles, Theme } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface Props {
  label: string;
}

const OutlinedLabel: React.FC<Props> = ({ label }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return <Chip className={classes.labelStyle} label={t(`${label}`)} variant={'outlined'} />;
};

const useStyles = makeStyles<Theme>((theme) => ({
  labelStyle: {
    height: '35%',
    opacity: '0.8',
    marginLeft: '-16px',
    textTransform: 'uppercase',
    fontSize: '11px',
    fontFamily: theme.typography.fontFamily,
    letterSpacing: '0.2px',
    color: '#FFF',
    bold: 'true',
    backgroundColor: '#a0b1ce',
    backgroundOpacity: '50%',
  },
}));

export default OutlinedLabel;
